<template>
  <div v-loading.fullscreen.lock="appStore.loading" class="app-root">
    <router-view />
  </div>
</template>

<script setup>
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()
</script>
